export default function LittleText({ data, diamond, quality }) {
    return (<section className="about-text-section">
        <img
            src={diamond}
            alt="Philosophy Detail"
            className="top-left-icon"
        />
        <div className="about-text-content">
            <p
                className="reveal-type"
                data-bg-color="#cccccc"
                data-fg-color="black"
            >
                {data?.description}
            </p>
        </div>
        <img
            src={quality}
            alt="Philosophy Detail"
            className="bottom-right-icon"
        />
    </section>
    )
}
